import { render, staticRenderFns } from "./UserImporter.vue?vue&type=template&id=5b753cbf"
import script from "./UserImporter.vue?vue&type=script&lang=js"
export * from "./UserImporter.vue?vue&type=script&lang=js"
import style0 from "./UserImporter.vue?vue&type=style&index=0&id=5b753cbf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports